import { useState } from 'react';

export default function Courses() {
  const [selectedAge, setSelectedAge] = useState('all');

  const courses = [
    {
      id: 1,
      title: "初階❤︎獨創主題式作文",
      age: "低年級",
      ageGroup: "elementary",
      duration: "1.5小時/堂",
      students: "4-6人小班",
      price: "18堂課一期",
      originalPrice: "",
      features: ["主題式作文教學", "高互動口說討論", "客製化問題點發現", "閱讀理解與素養", "基礎詞彙能力養成", "寫作素材累積"],
      description: "以低年級學生程度及課程綱要設計，結合老師們多年現場教學經驗，歷經疫情線上教學等一系列考驗，研發出最適合孩子的線上寫作學習內容，輕鬆無壓力的主題課程，深受孩子喜愛。",
      highlights: ["每兩堂課一個主題", "創作一篇作品", "培養寫作興趣"],
      image: "https://static.readdy.ai/image/6a4168e1db81f7a7fb40133af0c991e9/172379b2cc153cb395f10c760c4274b4.png"
    },
    {
      id: 2,
      title: "中階❤︎獨創主題式作文",
      age: "中年級",
      ageGroup: "elementary",
      duration: "1.5小時/堂",
      students: "4-6人小班", 
      price: "20堂課一期",
      originalPrice: "",
      features: ["主題式作文教學", "閱讀理解訓練", "討論互動學習", "個別程度調整", "客製化補充", "寫作基礎奠定"],
      description: "結合老師們多年現場教學經驗，歷經疫情線上教學等多次考驗，研發出最適合孩子的線上寫作學習模式，輕鬆無壓力的課程，深受孩子喜愛。",
      highlights: ["每兩堂課一個主題", "創作一篇作品", "幽默風趣教學"],
      image: "https://static.readdy.ai/image/6a4168e1db81f7a7fb40133af0c991e9/9340ef93b58d9a6794df98ca8e02a826.png"
    },
    {
      id: 3,
      title: "高階❤︎獨創主題式作文",
      age: "高年級",
      ageGroup: "elementary",
      duration: "1.5小時/堂",
      students: "4-6人小班",
      price: "20堂課一期", 
      originalPrice: "",
      features: ["高階主題式作文", "閱讀理解深化", "討論互動進階", "個別程度調整", "客製化補充", "未來基礎奠定"],
      description: "為未來打下紮實基礎！結合老師們多年現場教學經驗，歷經疫情線上教學等多次考驗，研發出最適合高年級學生的線上寫作學習模式，輕鬆無壓力的課程，深受孩子喜愛。",
      highlights: ["每兩堂課一個主題", "創作一篇作品", "紮實基礎培養"],
      image: "https://static.readdy.ai/image/6a4168e1db81f7a7fb40133af0c991e9/1f9f7ebaa570c7497359cf66f431bb46.png"
    },
    {
      id: 4,
      title: "國中❤︎獨創主題式作文",
      age: "國中生",
      ageGroup: "junior",
      duration: "1.5小時/堂",
      students: "小團班教學",
      price: "20堂課一期",
      originalPrice: "",
      features: ["會考作文準備", "各類型寫作", "閱讀理解進階", "個人風格發展", "作品賞析", "心智圖大綱"],
      description: "一路走來，始終以學生為出發點，解決您對於會考作文的困擾！結合老師們多年現場教學經驗，歷經疫情線上教學等不斷考驗，研發出最適合國中生的線上寫作學習模式，輕鬆無壓力的課程，青少年接受度極高。",
      highlights: ["會考應戰準備", "獨樹一格文章", "長期寫作能力"],
      image: "https://static.readdy.ai/image/6a4168e1db81f7a7fb40133af0c991e9/4fe36a926dd28d7ce5f3549b58c6a216.png"
    },
    {
      id: 5,
      title: "國學文言文精選課程",
      age: "國中/高年級",
      ageGroup: "advanced",
      duration: "50分鐘/堂",
      students: "4-6人小班",
      price: "20堂課一期",
      originalPrice: "",
      features: ["文言文閱讀分析", "文學史探討", "詩詞古文", "詞句練習", "古文語感培養", "私中考試準備"],
      description: "我們理解孩子跟您對於文言文閱讀解題的煩惱，結合老師們多年授課及教學經驗，設計出補充國學能量的文言文課程，輕鬆無壓力的課程，深受同學喜愛。",
      highlights: ["國學能量補充", "古文語感培養", "私中考試適用"],
      image: "https://static.readdy.ai/image/6a4168e1db81f7a7fb40133af0c991e9/32bee099dcadcbac5c9802b3e7eeec6a.jpeg"
    },
    {
      id: 6,
      title: "成語與字音字形練習",
      age: "國小高年級",
      ageGroup: "elementary",
      duration: "50分鐘/堂",
      students: "4-6人小班",
      price: "20堂課一期",
      originalPrice: "",
      features: ["成語故事教學", "字音字形練習", "趣味故事結合", "多元教學模式", "國語素養提升", "基礎實力培養"],
      description: "精選成語故事與字音字形練習，補充現代孩子因資訊及短影音爆炸而缺乏的課外實力，實際練習增強國語素養。包含國小領域中較常出現或是容易混淆的字詞及成語。",
      highlights: ["補充課外實力", "國語素養提升", "國小專屬設計"],
      image: "https://static.readdy.ai/image/6a4168e1db81f7a7fb40133af0c991e9/b47c70a79f3f6753bcb9e46a33df591a.png"
    }
  ];

  // 冬夏令營課程
  const campCourses = [
    {
      id: 7,
      title: "寒假寫作冬令營",
      age: "國小/國中",
      ageGroup: "camp",
      duration: "1.5小時/日",
      students: "4-6人小班",
      price: "5日一梯次",
      originalPrice: "",
      features: ["創意寫作主題", "獨家多元主題", "作品發表", "同儕互動", "創意啟發", "成果展示"],
      description: "寒假期間特別規劃的5日密集寫作營隊，透過創意寫作主題與獨家多元主題引導孩子發揮創意，在短時間內大幅提升寫作能力，營造濃厚的學習氛圍。",
      highlights: ["5日密集訓練", "創意寫作主題", "早鳥優惠價"],
      image: "https://static.readdy.ai/image/6a4168e1db81f7a7fb40133af0c991e9/79c74643ff13f85687723c0c50be98ef.png"
    },
    {
      id: 8,
      title: "暑假寫作夏令營",
      age: "國小/國中",
      ageGroup: "camp",
      duration: "1.5小時/日",
      students: "4-6人小班",
      price: "5日一梯次",
      originalPrice: "",
      features: ["創意寫作主題", "獨家多元主題", "文學賞析", "創意思維", "表達訓練", "作品集製作"],
      description: "暑假期間的寫作營隊，透過創意寫作主題與獨家多元主題，讓孩子在輕鬆的暑假氛圍中持續精進寫作技巧，培養深度思考能力。",
      highlights: ["5日完整訓練", "作品集製作", "暑期特惠"],
      image: "https://public.readdy.ai/ai/img_res/f6eb99b79855d8ce12d885097d869112.jpg"
    }
  ];

  const ageGroups = [
    { id: 'all', label: '全部課程', icon: 'ri-book-line' },
    { id: 'camp', label: '冬夏令營', icon: 'ri-sun-line' },
    { id: 'elementary', label: '國小課程', icon: 'ri-seedling-line' },
    { id: 'junior', label: '國中課程', icon: 'ri-plant-line' },
    { id: 'advanced', label: '增能課程', icon: 'ri-tree-line' }
  ];

  const allCourses = [...courses, ...campCourses];
  
  const filteredCourses = selectedAge === 'all' 
    ? allCourses 
    : allCourses.filter(course => course.ageGroup === selectedAge);

  const teachingMethods = [
    {
      icon: "ri-video-line",
      title: "線上互動教學",
      description: "使用專業視訊平台，支援螢幕分享、電子白板功能，讓線上學習如同面對面教學，即時互動零距離"
    },
    {
      icon: "ri-group-line", 
      title: "超迷你小班制",
      description: "每班嚴格控制4-6人，確保每位學生都能獲得充分的關注與個別指導，學習效果最大化"
    },
    {
      icon: "ri-edit-box-line",
      title: "主題式作文教學",
      description: "每兩堂課一個主題，創作一篇作品。透過閱讀理解、討論互動的方式，內化知識並增加寫作素材"
    },
    {
      icon: "ri-heart-line",
      title: "客製化教學調整",
      description: "老師們幽默風趣,針對孩子們的個別程度進行調整跟客製化補充，培養長期寫作興趣"
    },
    {
      icon: "ri-user-line",
      title: "個別評估",
      description: "專業老師個別評估學習狀況與需求"
    },
    {
      icon: "ri-book-open-line",
      title: "客製化建議",
      description: "根據試聽結果提供個人化學習建議"
    }
  ];

  const courseAdvantages = [
    {
      icon: "ri-medal-line",
      title: "專業師資團隊",
      description: "多年現場教學經驗，歷經疫情線上教學考驗，研發最適合的教學模式"
    },
    {
      icon: "ri-time-line",
      title: "系統化課程設計",
      description: "一週一堂課，20堂課一期，循序漸進的學習進度安排"
    },
    {
      icon: "ri-trophy-line",
      title: "培養寫作興趣",
      description: "輕鬆無壓力的課程設計，引導孩子寫作方向，培養長期寫作能力"
    },
    {
      icon: "ri-star-line",
      title: "多元課程選擇",
      description: "從基礎作文到國學文言文，滿足不同年齡層和學習需求"
    }
  ];

  // 強打課程 - 早鳥冬令營
  const winterCamp = {
    title: "早鳥冬令營",
    subtitle: "強打課程",
    description: "寒假規劃5日一梯次的獨家主題營隊，創意寫作主題、獨家多元主題",
    features: ["密集式教學", "假期專屬", "早鳥優惠", "小班教學"],
    image: "https://static.readdy.ai/image/6a4168e1db81f7a7fb40133af0c991e9/79c74643ff13f85687723c0c50be98ef.png"
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-pink-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-pink-500" style={{fontFamily: '"Pacifico", serif'}}>
                共學趣線上國語文寫作教室
              </h1>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <a href="/" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors">首頁</a>
                <a href="/courses" className="text-pink-500 font-medium px-3 py-2 rounded-md text-sm whitespace-nowrap cursor-pointer bg-pink-50 rounded-full">課程介紹</a>
                <a href="/teachers" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors">師資團隊</a>
                <a href="/results" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors">教學成果</a>
                <a href="/trial" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors">免費試聽</a>
              </div>
            </div>
            <div className="md:hidden">
              <button className="text-gray-700 hover:text-pink-500 w-6 h-6 flex items-center justify-center cursor-pointer">
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-pink-50 via-rose-50 to-pink-100 py-24">
        <div className="absolute inset-0 bg-white/30"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 bg-pink-500/10 text-pink-600 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <i className="ri-star-fill text-yellow-500"></i>
            <span>專業線上寫作教室</span>
          </div>
          <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6">
            獨創主題式
            <span className="text-pink-500 block lg-inline lg-ml-4">寫作課程</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8 leading-relaxed">
            從初階到進階，我們為不同年齡層的學生設計最適合的寫作課程<br/>
            每兩堂課一個主題，創作一篇作品，培養孩子的長期寫作興趣
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/trial" className="bg-pink-500 text-white px-8 py-4 rounded-full font-semibold hover:bg-pink-600 transition-colors whitespace-nowrap cursor-pointer shadow-lg">
              立即免費試聽
            </a>
            <button className="border-2 border-pink-500 text-pink-500 px-8 py-4 rounded-full font-semibold hover:bg-pink-500 hover:text-white transition-colors whitespace-nowrap cursor-pointer">
              了解更多課程
            </button>
          </div>
        </div>
      </section>

      {/* 強打課程 - 早鳥冬令營 */}
      <section className="py-20 bg-gradient-to-r from-pink-500 via-rose-500 to-pink-600 relative overflow-hidden">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <div className="inline-flex items-center gap-2 bg-white/20 text-white px-4 py-2 rounded-full text-sm font-medium mb-6">
                <i className="ri-fire-fill text-yellow-300"></i>
                <span>{winterCamp.subtitle}</span>
              </div>
              <h2 className="text-4xl lg:text-5xl font-bold mb-6">{winterCamp.title}</h2>
              <p className="text-xl text-pink-100 mb-8 leading-relaxed">
                {winterCamp.description}
              </p>
              <div className="grid grid-cols-2 gap-4 mb-8">
                {winterCamp.features.map((feature, index) => (
                  <div key={index} className="flex items-center gap-2">
                    <i className="ri-check-line text-green-300"></i>
                    <span className="text-pink-100">{feature}</span>
                  </div>
                ))}
              </div>
              <div className="flex gap-4">
                <a href="https://lin.ee/3Slg6R2Zx" target="_blank" rel="noopener noreferrer" className="bg-white text-pink-500 px-8 py-4 rounded-full font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer shadow-lg">
                  立即報名
                </a>
                <a 
                  href="/camp-schedule"
                  className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold hover:bg-white hover:text-pink-500 transition-colors whitespace-nowrap cursor-pointer"
                >
                  查看課表
                </a>
              </div>
            </div>
            <div className="relative">
              <img 
                src={winterCamp.image}
                alt="早鳥冬令營"
                className="w-full h-auto rounded-2xl shadow-2xl object-cover"
              />
              <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-lg">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center">
                    <i className="ri-calendar-line text-pink-500 text-xl"></i>
                  </div>
                  <div>
                    <p className="font-bold text-gray-900">寒假專屬</p>
                    <p className="text-sm text-gray-600">早鳥優惠</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Course Filter */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              常態班課程
            </h2>
            <p className="text-lg text-gray-600">
              根據年齡層和程度選擇最適合的寫作課程
            </p>
          </div>
          
          <div className="flex justify-center mb-16">
            <div className="bg-gray-50 rounded-2xl p-2 flex gap-2 flex-wrap justify-center">
              {ageGroups.map((group) => (
                <button
                  key={group.id}
                  onClick={() => setSelectedAge(group.id)}
                  className={`px-6 py-4 rounded-xl font-medium transition-all whitespace-nowrap cursor-pointer flex items-center gap-2 ${
                    selectedAge === group.id
                      ? 'bg-pink-500 text-white shadow-lg transform scale-105'
                      : 'text-gray-600 hover:bg-white hover:shadow-md'
                  }`}
                >
                  <i className={group.icon}></i>
                  {group.label}
                </button>
              ))}
            </div>
          </div>

          {/* Courses Grid */}
          <div className="grid lg:grid-cols-2 gap-8">
            {filteredCourses.map((course) => (
              <div key={course.id} className="bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:transform hover:scale-105 border border-gray-100">
                <div className="relative h-56">
                  <img 
                    src={course.image}
                    alt={course.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                  <div className="absolute top-4 right-4 bg-pink-500 text-white px-4 py-2 rounded-full text-sm font-medium shadow-lg">
                    {course.age}
                  </div>
                  <div className="absolute bottom-4 left-4 flex gap-2">
                    {course.highlights.map((highlight, index) => (
                      <span key={index} className="bg-white/90 text-gray-800 px-3 py-1 rounded-full text-xs font-medium">
                        {highlight}
                      </span>
                    ))}
                  </div>
                </div>
                
                <div className="p-8">
                  <div className="flex items-start justify-between mb-4">
                    <h3 className="text-2xl font-bold text-gray-900">{course.title}</h3>
                    <div className="text-right">
                      <div className="text-lg font-bold text-pink-500">{course.price}</div>
                      {course.originalPrice && (
                        <div className="text-sm text-gray-400 line-through">{course.originalPrice}</div>
                      )}
                    </div>
                  </div>
                  
                  <p className="text-gray-600 mb-6 leading-relaxed">{course.description}</p>
                  
                  <div className="grid grid-cols-2 gap-4 mb-6">
                    <div className="flex items-center gap-3 p-3 bg-pink-50 rounded-xl">
                      <div className="w-10 h-10 bg-pink-100 rounded-full flex items-center justify-center">
                        <i className="ri-time-line text-pink-500"></i>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500">課程時長</p>
                        <p className="font-medium text-gray-800">{course.duration}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3 p-3 bg-blue-50 rounded-xl">
                      <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                        <i className="ri-group-line text-blue-500"></i>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500">班級人數</p>
                        <p className="font-medium text-gray-800">{course.students}</p>
                      </div>
                    </div>
                  </div>

                  <div className="mb-6">
                    <h4 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                      <i className="ri-star-line text-pink-500"></i>
                      課程特色
                    </h4>
                    <div className="grid grid-cols-2 gap-2">
                      {course.features.map((feature, index) => (
                        <div key={index} className="flex items-center gap-2 py-1">
                          <i className="ri-check-line text-green-500 text-sm"></i>
                          <span className="text-sm text-gray-600">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="flex gap-3">
                    <a href="https://lin.ee/3Slg6R2Zx" target="_blank" rel="noopener noreferrer" className="flex-1 bg-pink-500 text-white py-3 rounded-xl font-medium hover:bg-pink-600 transition-colors whitespace-nowrap cursor-pointer text-center">
                      免費試聽或報名
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Teaching Methods */}
      <section className="py-20 bg-gradient-to-br from-pink-50 to-rose-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              獨創教學方式
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              結合多年現場教學經驗，歷經疫情線上教學考驗，研發出最適合孩子的學習模式
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {teachingMethods.map((method, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 text-center hover:shadow-xl transition-all duration-300 hover:transform hover:-translate-y-2 border border-gray-100">
                <div className="w-16 h-16 bg-gradient-to-br from-pink-100 to-rose-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className={`${method.icon} text-2xl text-pink-500`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{method.title}</h3>
                <p className="text-gray-600 leading-relaxed">{method.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Course Advantages */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              系統化課程設計
            </h2>
            <p className="text-lg text-gray-600">
              一週一堂課，20堂課一期，循序漸進的學習進度安排
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {courseAdvantages.map((advantage, index) => (
              <div key={index} className="text-center group">
                <div className="w-20 h-20 bg-gradient-to-br from-pink-500 to-rose-500 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${advantage.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{advantage.title}</h3>
                <p className="text-gray-600 leading-relaxed">{advantage.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-pink-500 via-rose-500 to-pink-600 relative overflow-hidden">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            找到適合的課程了嗎？
          </h2>
          <p className="text-xl text-pink-100 mb-8 max-w-2xl mx-auto leading-relaxed">
            立即預約免費試聽，讓我們為您的孩子量身打造最適合的學習計畫<br/>
            專業師資團隊等您來體驗
          </p>
          <div className="flex justify-center">
            <a href="https://lin.ee/3Slg6R2Zx" target="_blank" rel="noopener noreferrer" className="bg-white text-pink-500 px-8 py-4 rounded-full font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer shadow-lg">
              立即免費試聽 &amp; 課程諮詢
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <h3 className="text-2xl font-bold mb-4 text-pink-400" style={{fontFamily: '"Pacifico", serif'}}>
                共學趣線上國語文寫作教室
              </h3>
              <p className="text-gray-400 mb-6 leading-relaxed">
                專業線上寫作教室，致力於培養孩子的寫作能力與創意思維。
                我們相信每個孩子都有無限潛能，只需要正確的引導。
              </p>
              <div className="flex gap-4">
                <a href="https://lin.ee/3Slg6R2Zx" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors cursor-pointer">
                  <i className="ri-line-fill text-lg"></i>
                </a>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">快速連結</h4>
              <ul className="space-y-2">
                <li><a href="/courses" className="text-gray-400 hover:text-white transition-colors cursor-pointer">課程介紹</a></li>
                <li><a href="/teachers" className="text-gray-400 hover:text-white transition-colors cursor-pointer">師資團隊</a></li>
                <li><a href="/results" className="text-gray-400 hover:text-white transition-colors cursor-pointer">教學成果</a></li>
                <li><a href="/trial" className="text-gray-400 hover:text-white transition-colors cursor-pointer">免費試聽</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">聯絡資訊</h4>
              <ul className="space-y-2 text-gray-400">
                <li className="flex items-center gap-2">
                  <i className="ri-line-fill"></i>
                  <a href="https://lin.ee/3Slg6R2Zx" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">@write123</a>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-fill"></i>
                  <span>週一至週日 9:00-21:00</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-global-fill"></i>
                  <span>線上教學，不限地區</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2025 共學趣線上寫作教室. All rights reserved. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer ml-2">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
